<template>
  <section id="results-files">
    <ul class="filters-list">
      <li
        :class="{
          'router-link-active-parent': $route.name == 'allResults',
        }"
      >
        <router-link
          :to="{
            name: 'allResults',
            query: this.$route.query,
          }"
        >
          ALL
          <span class="active-icon">
            <img src="@/assets/images/caret-down-fill.svg" alt="" /> </span
        ></router-link>
      </li>
      <li>
        <router-link
          :to="{
            name: 'ActiveResults',
            query: this.$route.query,
          }"
        >
          ACTIVE
          <span class="active-icon">
            <img src="@/assets/images/caret-down-fill.svg" alt="" /> </span
        ></router-link>
      </li>
      <li>
        <router-link
          :to="{
            name: 'ToStartResults',
            query: this.$route.query,
          }"
        >
          TO-START
          <span class="active-icon">
            <img src="@/assets/images/caret-down-fill.svg" alt="" /> </span
        ></router-link>
      </li>
      <li>
        <router-link
          :to="{
            name: 'ProcessingResults',
            query: this.$route.query,
          }"
        >
          PROCESSING
          <span class="active-icon">
            <img src="@/assets/images/caret-down-fill.svg" alt="" /> </span
        ></router-link>
      </li>

      <li>
        <router-link
          :to="{
            name: 'CompleteResults',
            query: this.$route.query,
          }"
        >
          COMPLETED
          <span class="active-icon">
            <img src="@/assets/images/caret-down-fill.svg" alt="" /> </span
        ></router-link>
      </li>
      <li>
        <router-link
          :to="{
            name: 'ArchiveResults',
            query: this.$route.query,
          }"
        >
          ARCHIVED
          <span class="active-icon">
            <img src="@/assets/images/caret-down-fill.svg" alt="" /> </span
        ></router-link>
      </li>
    </ul>
  </section>
</template>
<style lang="scss">
#results-files {
  a {
    white-space: nowrap;
  }
}
</style>
